$(document).ready(function() {
  // Manejar el clic en el botón de asignar candidato
  $("#profileModal").on("click", ".form-postulation-assign .assign", function(e) {    
    e.preventDefault();
    var $this = $(this);

    Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Deseas asignar este candidato a este proceso?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, asignar",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.value) {
        showLoadingAlert();
        createAssign($this);
      }
    });
  });

  function showLoadingAlert(){
    Swal.fire({
      title: "Asignando...",
      text: "Por favor espere mientras se asigna el candidato",
      icon: "info",
      allowEscapeKey: false,
      allowEnterKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false
    });
  }

  function createAssign($this){
    // var rowID = $this.parent().parent().parent().parent().parent().data("row");
    var container = $this.parent().parent();
    var url = $this.parent().attr("action");
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');

    $.ajax({
      url: url,
      method: "POST",
      dataType: 'json',
      data: {
        authenticity_token: AUTH_TOKEN
      },
      success: function(response) {
        successAlert();
        addLabel(container);
      },
      error: function(response) {
        errorAlert();
      }
    });
  }

  function successAlert(){
    Swal.fire({
      title: "¡Listo!",
      text: "El candidato ha sido asignado correctamente",
      icon: "success"
    });
  }

  function addLabel(container){
    container.html('<span class="badge badge-secondary">Postulando</span>');
  }

  function errorAlert(){
    Swal.fire({
      title: "¡Error!",
      text: "Ha ocurrido un error al asignar el candidato",
      icon: "error"
    });
  }

});